module.exports = __webpack_public_path__ + "img/finland-diabetes-mellitus-male.14d5da5a.png";